const baseKey = '/v1/merchant/dashboard'

export const dashboardMerchantApi = {
  baseKey,
  topups: `${baseKey}/payments/topups`,
}
